/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../components/label";
import MyProfileForm from "../../containers/MyProfileForm";
import { NavLink } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import MakeAPICall from "../../apiCalls/common";


class ProfilePage extends Component {
  
  constructor(props){
    super(props);
    this.state = {
      userData : null,
      apiCall: null,
    };
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  };

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  render() {
    return (
      <div className="row rounded p-3 my-profile-page">
        <div className="col-sm-3 p-3">
          <Label title="My Profile" className="big" />
        </div>
        <div className="col-sm-3 offset-sm-6 p-3 text-right">
          <NavLink
            to={appRoutes.editProfile}
            className="btn insta-button-primary pt-2"
            href="#"
          >
            <i className="fas fa-pencil-alt font-15 mr-3"></i>
            <span className="font-15">Edit</span>
          </NavLink>
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-4">
          <MyProfileForm makeAPICall={this.componentAPICall}/>
        </div>
          {/* API Call */}
          <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

export default ProfilePage;
